import { useTranslation } from 'react-i18next';
import { GLOBAL_NAVIGATION_HEIGHT } from '@/shared/lib/constants';
import { useRouteSidePanelStore } from '@/shared/stores/side-panel-store';
import { Banner } from '@/shared/ui';
import { SideMenuHeader } from '@/widgets/right-side-menu/ui/SideMenuHeader';
import { RevenueAppropriationExpenditureForm } from './RevenueAppropriationExpenditureForm';

/**
 * 財源充当（歳出）サイドパネル
 *
 * 歳入テーブルの「追加」または歳出サマリーの「編集」で表示されるコンテナ。
 * mode に応じて追加・編集を切り替える。
 */
export const RevenueAppropriationExpenditureSidePanel = () => {
  const { t } = useTranslation();
  const requestClose = useRouteSidePanelStore((state) => state.requestClose);
  const mode = useRouteSidePanelStore((state) => state.mode);

  const panelMode =
    mode?.type === 'settlement-statistics-converter.revenue-appropriation' ? mode : undefined;

  return (
    <div
      className="flex flex-col overflow-hidden"
      style={{ height: `calc(100vh - ${GLOBAL_NAVIGATION_HEIGHT}px)` }}
    >
      <SideMenuHeader onClose={() => requestClose()} />
      {panelMode ? (
        panelMode.mode === 'create' ? (
          <RevenueAppropriationExpenditureForm
            mode="create"
            key={panelMode.revenueRecord.revenue_record_id} // createとeditで同じレコードを開いたときにフォームの状態がリセットされるようにkeyを指定
            convertResultId={panelMode.convertResultId}
            revenueRecord={panelMode.revenueRecord}
            onClose={requestClose}
          />
        ) : (
          <RevenueAppropriationExpenditureForm
            mode="edit"
            key={panelMode.revenueAppropriationId} // createとeditで同じレコードを開いたときにフォームの状態がリセットされるようにkeyを指定
            convertResultId={panelMode.convertResultId}
            revenueAppropriationId={panelMode.revenueAppropriationId}
            expenditureSummary={panelMode.expenditureSummary}
            onClose={requestClose}
          />
        )
      ) : (
        <Banner
          type="error"
          title={t('common.status.error')}
          description={t('common.status.no-data')}
        />
      )}
    </div>
  );
};
